import NewUser from "../components/NewUser/NewUser";
import { CollapsedNavBar, NavBar } from "../components/newNavbar/navbar";

const AddAdmin = () => {
  const roles = [
    { name: "Super Admin", disabled: false },
    { name: "Admin", disabled: false },
    { name: "Operator", disabled: false },
  ];

  return (
    <div id="page-container">
      <NavBar />
      <CollapsedNavBar />
      <div id="page-content">
        <div className="flexCenterXY mx-5 pt-4">
          <NewUser title="Admin" roles={roles}></NewUser>
        </div>
      </div>
    </div>
  );
};
export default AddAdmin;
